/**
 *
 * FormField
 *
 */

import React, { memo, FunctionComponent, Children } from 'react';
import { Wrap } from '../../assets/styledAssets/grid';
import {
  StyledCheckBox,
  StyledDropDownList,
  StyledDropDownListTransparent,
  StyledDropDownListTransparentPrimary,
  StyledFormField,
  StyledLabel,
  StyledRadioButton,
} from './styles';
import { fontColorSecond } from '../../assets/styledAssets/vars';
import { Input } from '@progress/kendo-react-inputs';

interface IProps {
  label?: any;
  type?: any;
  placeholder?: any;
  defaultVal?: any;
  items?: any;
  children?: any;
  postfix?: any;
  optional?: string;
  radioName?: any;
  radioVal?: any;
  radioLabel?: any;
  textField?: any;
  dataItemKey?: any;
  value?: any;
  onChange?: any;
  transparent?: boolean;
  primary?: boolean;
  checked?: any;
}

const FormField: FunctionComponent<IProps> = ({
  label,
  type,
  placeholder,
  defaultVal,
  items,
  children,
  postfix,
  optional,
  radioName,
  radioVal,
  radioLabel,
  textField,
  dataItemKey,
  value,
  onChange,
  transparent,
  primary,
  checked,
  ...rest
}) => {
  return (
    <Wrap
      flexDir={type !== 'radio' ? 'column' : 'row'}
      className={type !== 'radio' ? 'field' : 'field-radio'}
      width={type !== 'radio' ? '100%' : 'auto'}
    >
      {/*{...rest}*/}
      {label && type !== 'radio' && (
        <StyledLabel>
          {label}
          {optional && (
            <Wrap margin={'0 0 0 .4rem'} fs="1.1rem" color={fontColorSecond}>
              ({optional})
            </Wrap>
          )}
        </StyledLabel>
      )}
      {type === 'select' ? (
        transparent ? (
          primary ? (
            <StyledDropDownListTransparentPrimary
              textField={textField}
              {...rest}
              data={items}
              value={value}
              defaultValue={value}
              onChange={onChange}
            />
          ) : (
            <StyledDropDownListTransparent
              textField={textField}
              {...rest}
              data={items}
              value={value}
              defaultValue={value}
              onChange={onChange}
            />
          )
        ) : (
          <StyledDropDownList
            textField={textField}
            {...rest}
            data={items}
            value={value}
            defaultValue={value}
            onChange={onChange}
          />
        )
      ) : type === 'radio' ? (
        <StyledRadioButton
          checked={checked}
          name={radioName}
          onChange={onChange}
          value={radioVal}
          label={radioLabel}
        />
      ) : type === 'check' || type === 'checkbox' ? (
        <StyledCheckBox
          className={'field-checkbox'}
          checked={checked}
          name={radioName}
          onChange={onChange}
          value={radioVal}
          label={radioLabel}
        />
      ) : (
        <StyledFormField>
          <Input
            value={value}
            onChange={onChange}
            className={`form-field__input ${postfix && 'has-postfix'}`}
            type={type}
            placeholder={placeholder}
          />
          {Children.toArray(postfix)}
        </StyledFormField>
      )}
    </Wrap>
  );
};

export default memo(FormField);
